module.exports = __webpack_public_path__ + "assets/img/de-e82ac3a1.png";